export const SHOW_BAR = 'SHOW_BAR'
export const HIDE_BAR = 'HIDE_BAR'
